module.exports = __webpack_public_path__ + "img/logo-mib.baa8e597.svg";